import { ChangeDetectionStrategy, Component, effect, input, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule, ValidatorFn } from '@angular/forms';
import { FormErrorComponent } from '../../form-error/form-error.component';
import { v4 as uuidv4 } from 'uuid';
import { htmlMaxCharacterValidator } from '../../../../validators/html-max-characterl.validator';
import { startWith } from 'rxjs';
import { TextareaInputComponent } from '../../inputs/textarea-input/textarea-input.component';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'lib-textarea-form-field',
  imports: [ReactiveFormsModule, FormErrorComponent, TextareaInputComponent, DecimalPipe],
  templateUrl: './textarea-form-field.component.html',
  styleUrl: './textarea-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextareaFormFieldComponent {
  inputFormControl = input.required<FormControl>();
  label = input.required<string>();
  isSubmitted = input<boolean>(false);
  placeholder = input<string | null | undefined>();
  hintText = input<string | null | undefined>();
  rows = input<number>(3);
  maxCharacters = input<number | null>(null);
  protected charCount = signal<number>(0);

  inputId: string = uuidv4();
  private maxCharacterValidator: ValidatorFn | null = null;

  formControlEffect = effect(() => {
    this.inputFormControl()
      .valueChanges.pipe(startWith(this.inputFormControl().value))
      .subscribe(value => this.charCount.set(value?.length ?? 0));
  });

  characterCountEffect = effect(() => {
    const maxCharacters = this.maxCharacters();
    if (maxCharacters !== null) {
      this.maxCharacterValidator = htmlMaxCharacterValidator(maxCharacters);
      this.inputFormControl().addValidators(this.maxCharacterValidator);
    } else if (this.maxCharacterValidator) {
      this.inputFormControl().removeValidators(this.maxCharacterValidator);
    }
  });
}
